export default __webpack_public_path__ + "static/media/b01_c.6e445321.png";